import { CollapsibleSection } from "@/components/collapsible-section";
import {
  SituationNarrative,
  SituationTension,
} from "@/components/experience/situation-narrative";

interface SituationBlockProps {
  outlineId: string;
  narrative: string | null;
  tension: string | null;
}

export function SituationBlock({
  outlineId,
  narrative,
  tension,
}: SituationBlockProps) {
  // Render when either a narrative or a tension exists. If only tension
  // is set, the preview falls back to the tension phrase so the collapsed
  // state still carries signal.
  if (!narrative && !tension) return null;

  const previewSource = narrative ?? tension ?? "";
  const words = previewSource.split(/\s+/);
  const preview = words.slice(0, 12).join(" ");
  const hasMore = words.length > 12;

  return (
    <CollapsibleSection
      label="Situation"
      storageKey={`scenario-detail-${outlineId}-situation`}
      previewText={hasMore ? `${preview}…` : preview}
      ariaLabel="Situation"
    >
      <div className="space-y-4">
        {narrative && <SituationNarrative>{narrative}</SituationNarrative>}
        {tension && <SituationTension>{tension}</SituationTension>}
      </div>
    </CollapsibleSection>
  );
}
